export const milesToKm = (miles: number | undefined) => {
  if (miles === undefined) {
    return 0
  }

  return (miles * 1.60934).toFixed(0)
}

export const kmToMiles = (km: number) => {
  return (km / 1.60934).toFixed(0)
}
